// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__KuT-s","wrap":"Layout_wrap__3Y4cM","content":"Layout_content__3nMgS"};